import { memo, useContext } from 'react';
import { default as ReactGA4 } from 'react-ga4';
import { twMerge } from 'tailwind-merge';
import cn from 'classnames';
import { Element, RouterLink } from 'src/components';
import { SearchDropdownContext } from '.';

interface IProps {
    id: string;
    value: string;
    onClick: () => void;
    isTopic?: boolean;
    index: number;
}

const SearchItem = ({ id, value, onClick, isTopic, index }: IProps) => {
    const currFocus = useContext(SearchDropdownContext);
    const url = isTopic ? `/t${id}.epi` : `/c${id}.epi`;

    const handleClick = () => {
        if (onClick) {
            onClick();
        }

        ReactGA4.event({
            category: 'mobile_search',
            action: 'clickSuggestion',
        });
    };

    return (
        <Element key={id} renderAs="li" className={cn('search-item')}>
            <RouterLink
                to={url}
                onClick={handleClick}
                className={twMerge(
                    'relative',
                    'flex items-center',
                    'w-full',
                    'px-[12px] py-[10px]',
                    cn({
                        ['bg-[#2FA1B3]/5']: currFocus === index,
                    }),
                )}
            >
                <Element dangerouslySetInnerHTML={{ __html: value }} />
                {isTopic && (
                    <Element
                        className={cn(
                            'ml-auto',
                            'text-[10px] font-[800] text-[#999]',
                            'shrink-0',
                            'pl-[5px]',
                        )}
                    >
                        CHỦ ĐỀ
                    </Element>
                )}
            </RouterLink>
        </Element>
    );
};

export default memo(SearchItem);
